(function() {
    const sectionScript = document.currentScript;
    if (!sectionScript) return;
    const sectionId = sectionScript.dataset.sectionId;
    const sectionSelector = '#shopify-section-' + sectionId;
    const mobileMediaQuery = window.matchMedia('(max-width: 750px)');
    const registry = window.__mpCreatorsSectionRegistry || (window.__mpCreatorsSectionRegistry = {});
    let swiperInstance = null;
    let observedImages = [];

    if (registry[sectionId] && typeof registry[sectionId].cleanup === 'function') {
        registry[sectionId].cleanup();
    }

    const equalizeDesktopCardBodies = function(sectionRoot) {
        if (!sectionRoot) {
            return;
        }

        const itemBodies = Array.from(sectionRoot.querySelectorAll('.mp-creators__item-body'));

        itemBodies.forEach(function(body) {
            body.style.minHeight = '';
        });

        if (mobileMediaQuery.matches || itemBodies.length === 0) {
            return;
        }

        const rows = new Map();

        itemBodies.forEach(function(body) {
            const rowKey = Math.round(body.getBoundingClientRect().top);
            const currentRow = rows.get(rowKey) || [];
            currentRow.push(body);
            rows.set(rowKey, currentRow);
        });

        rows.forEach(function(rowBodies) {
            const maxHeight = rowBodies.reduce(function(height, body) {
                return Math.max(height, body.offsetHeight);
            }, 0);

            rowBodies.forEach(function(body) {
                body.style.minHeight = maxHeight + 'px';
            });
        });
    };

    const scheduleEqualize = function(sectionRoot) {
        window.requestAnimationFrame(function() {
            equalizeDesktopCardBodies(sectionRoot);
        });
    };

    const bindImageListeners = function(sectionRoot) {
        observedImages.forEach(function(entry) {
            entry.image.removeEventListener('load', entry.handler);
        });

        observedImages = [];

        if (!sectionRoot) {
            return;
        }

        const images = Array.from(sectionRoot.querySelectorAll('.mp-creators__item img'));

        images.forEach(function(image) {
            if (image.complete) {
                return;
            }

            const handler = function() {
                scheduleEqualize(sectionRoot);
            };

            image.addEventListener('load', handler, { once: true });
            observedImages.push({ image: image, handler: handler });
        });
    };

    const destroySlider = function() {
        if (swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
        }
    };

    const syncSliderState = function(sectionRoot) {
        if (!sectionRoot || typeof Swiper === 'undefined') {
            return;
        }

        const swiperElement = sectionRoot.querySelector(`[data-swiper-id="mp-creators-slider-${sectionId}"]`);

        if (!swiperElement) {
            return;
        }

        if (!mobileMediaQuery.matches) {
            destroySlider();
            return;
        }

        if (swiperInstance) {
            swiperInstance.update();
            return;
        }

        const prevButton = sectionRoot.querySelector(`[data-prev-${sectionId}]`);
        const nextButton = sectionRoot.querySelector(`[data-next-${sectionId}]`);

        swiperInstance = new Swiper(swiperElement, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 24,
            loop: false,
            navigation: {
                prevEl: prevButton,
                nextEl: nextButton
            },
            watchOverflow: true
        });
    };

    const initializeSection = function(sectionRoot) {
        if (!sectionRoot || !sectionRoot.matches(sectionSelector)) {
            return;
        }

        syncSliderState(sectionRoot);
        scheduleEqualize(sectionRoot);
        bindImageListeners(sectionRoot);
    };

    const initialSection = document.querySelector(sectionSelector);
    initializeSection(initialSection);

    const handleMediaChange = function() {
        const currentSection = document.querySelector(sectionSelector);
        initializeSection(currentSection);
    };

    const handleResize = function() {
        const currentSection = document.querySelector(sectionSelector);
        scheduleEqualize(currentSection);
    };

    const handleSectionLoad = function(event) {
        initializeSection(event.target);
    };

    const handleSectionUnload = function(event) {
        if (event.target && event.target.matches(sectionSelector)) {
            observedImages.forEach(function(entry) {
                entry.image.removeEventListener('load', entry.handler);
            });
            observedImages = [];
            destroySlider();
        }
    };

    mobileMediaQuery.addEventListener('change', handleMediaChange);
    window.addEventListener('resize', handleResize);
    document.addEventListener('shopify:section:load', handleSectionLoad);
    document.addEventListener('shopify:section:unload', handleSectionUnload);

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function() {
            const currentSection = document.querySelector(sectionSelector);
            scheduleEqualize(currentSection);
        });
    }

    registry[sectionId] = {
        cleanup: function() {
            observedImages.forEach(function(entry) {
                entry.image.removeEventListener('load', entry.handler);
            });
            observedImages = [];
            destroySlider();
            mobileMediaQuery.removeEventListener('change', handleMediaChange);
            window.removeEventListener('resize', handleResize);
            document.removeEventListener('shopify:section:load', handleSectionLoad);
            document.removeEventListener('shopify:section:unload', handleSectionUnload);
        }
    };
})();
